import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.VUE_APP_API,
  withCredentials: true,
  timeout: 5000,

  // Axios 1.6.2+:
  // Send XSRF-TOKEN cookie as X-XSRF-TOKEN header
  // even when calling api.roguerust.com
  // from roguerust.com.
  withXSRFToken: true,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  headers: {
    Accept: 'application/json',
  },
})

instance.interceptors.request.use(
  function (config) {
    let currency = localStorage.getItem('currency')

    if (!currency) {
      currency = 'EUR'
    }

    const method = String(config.method || 'get').toLowerCase()

    if (method === 'get') {
      config.params = {
        ...config.params,
        currency,
      }
    } else if (['post', 'put', 'patch'].includes(method)) {
      // Preserve the original payload.
      // Do not overwrite FormData uploads.
      if (config.data instanceof FormData) {
        config.data.append('currency', currency)
      } else if (config.data && typeof config.data === 'object') {
        config.data = {
          ...config.data,
          currency,
        }
      } else if (!config.data) {
        config.data = { currency }
      }
    }

    return config
  },
  function (error) {
    return Promise.reject(error)
  },
)

export default instance
